import { render, staticRenderFns } from "./PlatformCountTable.vue?vue&type=template&id=324c980b&"
import script from "./PlatformCountTable.vue?vue&type=script&lang=ts&"
export * from "./PlatformCountTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports